var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCart, getProductByHandle, resizeShopifyImage, updateItemInCart, } from './helpers';
/** Shopify storefront helpers based on https://shopify.dev/api/ajax */
window._fwnStoreFront = {
    settings: { name: 'Shopify', cartUrl: location.origin + '/cart' },
};
document.addEventListener('fw:shopping:hydrate-products', (event) => __awaiter(void 0, void 0, void 0, function* () {
    const { products, actions } = event.detail;
    products.forEach((fwProduct) => {
        getProductByHandle(fwProduct.product_handle)
            .catch(() => null)
            .then((shopifyProduct) => {
            if (shopifyProduct) {
                actions.shopping.hydrateProduct(({ productFactory }) => productFactory((p) => {
                    const product = p
                        .description(shopifyProduct.description)
                        .ext_id(shopifyProduct.id)
                        .name(shopifyProduct.title);
                    // Process existing images for appening size
                    fwProduct.product_images.forEach((product_image) => product.image((i) => i
                        .ext_id(product_image.image_ext_id)
                        .position(product_image.image_position)
                        .url(resizeShopifyImage(product_image.image_src))
                        ._image_id(product_image.image_id)
                        ._unit_ids(product_image.unit_ids)
                        ._unit_ext_ids(product_image.unit_ext_ids)));
                    // Process variants and its images
                    shopifyProduct.variants.forEach((shopifyVariant) => {
                        product.variant((v) => {
                            const variant = v
                                .ext_id(shopifyVariant.id)
                                .isAvailable(shopifyVariant.available)
                                .name(shopifyVariant.title)
                                .price(shopifyVariant.price / 100)
                                .sku(shopifyVariant.sku)
                                .url(`${window.origin}${shopifyProduct.url}?variant=${shopifyVariant.id}`);
                            if (shopifyVariant.featured_image) {
                                variant.image((i) => i
                                    .ext_id(shopifyVariant.featured_image.id)
                                    .position(shopifyVariant.featured_image.position)
                                    .title(shopifyVariant.featured_image.alt)
                                    .url(resizeShopifyImage(shopifyVariant.featured_image.src)));
                            }
                            shopifyProduct.options.forEach(({ name, position }) => {
                                shopifyVariant.options[position - 1] &&
                                    variant.option({
                                        name,
                                        value: shopifyVariant.options[position - 1],
                                    });
                            });
                            return variant;
                        });
                    });
                    return product;
                }));
            }
            else {
                // eslint-disable-next-line no-console
                console.warn(`Cant fetch product by handle "${fwProduct.product_handle}"`);
            }
        });
    });
}));
document.addEventListener('fw:shopping:hydrate-cart', (event) => __awaiter(void 0, void 0, void 0, function* () {
    const { actions } = event.detail;
    const cart = yield getCart();
    const { currency, items } = cart;
    actions.cart.configure({ currency, locale: 'en-US' });
    items.forEach((item) => {
        // getProductByHandle(item.handle)
        // .catch(() => null)
        // .then((shopifyProduct: IShopifyProduct)
        actions.cart.updateProduct(({ productFactory }) => productFactory((p) => p
            .currency(currency)
            .description(item.product_description)
            .ext_id(item.product_id)
            .name(item.product_title)
            .variant((v) => {
            const variant = v
                .ext_id(item.variant_id)
                .isAvailable(true)
                .name(item.title)
                .price(item.final_price / 100)
                .sku(item.sku)
                .url(`${window.origin}${item.url}`);
            item.featured_image &&
                item.featured_image.url &&
                variant.image((i) => i
                    .title(item.featured_image.alt)
                    .url(resizeShopifyImage(item.featured_image.url)));
            item.options_with_values.forEach(({ name, value }) => {
                variant.option({ name, value });
            });
            return variant;
        })));
        actions.cart.updateProductQuantity({
            id: item.id,
            quantity: item.quantity,
        });
    });
}));
document.addEventListener('fw:shopping:cart-updated', (event) => __awaiter(void 0, void 0, void 0, function* () {
    updateItemInCart(event.detail.product_unit.unit_ext_id, event.detail.quantity);
}));
document.addEventListener('fw:shopping:request-checkout', () => __awaiter(void 0, void 0, void 0, function* () {
    // Request checkout
}));
